import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaPlanesTurismo from './TablaPlanesTurismo';

const PlaneacionTuristica: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaPlanesTurismo />
    </Box>
  );
};

export default PlaneacionTuristica;
